module.exports = __webpack_public_path__ + "static/media/Screening2.692421fe.svg";